<template>
    <div class="edit-group">
        <el-dialog
            title="编辑卡组"
            :visible.sync="dialogVisible"
            width="600"
            :before-close="handleClose">
            <div>
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="卡组名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="卡组类型">
                        <el-select v-model="form.deck_type" placeholder="请选择卡组类型">
                        <el-option label="单图片卡组" value="1"></el-option>
                        <el-option label="双图片卡组" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="卡组封面">
                        <el-input v-model="form.cover_img_url" placeholder="卡组封面"></el-input>
                    </el-form-item>
                    <el-form-item label="卡组排序">
                        <el-input v-model="form.deck_sort"></el-input>
                    </el-form-item>
                    <el-form-item label="卡组描述">
                        <el-input type="textarea" v-model="form.desc"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {createGroup,updateGroup,detailGroup} from '../api/index'
export default {
    name:'EditCard',
    props:['showCardDetail','formData'],
    data() {
        return {
            form:{
                name:'',
                deck_type:'',
                deck_sort:'',
                desc:'',
                id:'',
                cover_img_url:''
            },
            dialogVisible:false,
            cards:[]
        }
    },
    watch:{
        showCardDetail:{
            handler(newV){
                this.dialogVisible = newV
            },
            immediate: true
        },
        formData:{
            handler(newV){
                if(!newV.length){
                    this.form = {
                        name:'',
                        deck_type:'',
                        deck_sort:'',
                        desc:'',
                        id:''
                    }
                }
                this.form = {...this.form,...newV}
                if(this.form.id) {
                    this.detailGroup();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleClose() {
            this.$emit('closeDetail',false)
        },
        detailGroup(){
            detailGroup({id:this.form.id}).then(res => {
                var cards = res.data.cards||[]
                var newCards = []
                for(var i=0;i<cards.length;i++) {
                    newCards.push({id:cards[i].id})
                }
                this.cards = newCards
            })
        },
        submit(){
            this.$confirm('确认提交？').then(() => {
                this.form.deck_sort = this.form.deck_sort-0
                this.form.cards = this.cards
                if(this.form.id){
                    updateGroup(this.form).then(res => {
                        console.log(res)
                        this.$message('更新成功');
                        this.$emit('closeDetail',true)
                    })
                }else {
                    delete this.form.id
                    createGroup(this.form).then(res => {
                        console.log(res)
                        this.$message('新增成功');
                        this.$emit('closeDetail',true)
                    })
                }
            }).catch(() => {});
        },
        cancel(){
            this.$emit('closeDetail',false)
        }
    },
}
</script>
<style lang="scss">
</style>
